// extracted by mini-css-extract-plugin
export default {"detailsRow":"DetailsRow_detailsRow__2fDzX"};